module.exports = __webpack_public_path__ + "static/marie-4b69277f159aff31509f750865b83917.png";